<template>
  <ui-dialog show max-width="542px" @input="$emit('close')">
    <template #header>
      <h3>{{ $t("message.reviews.aiReply.settingsAiReply") }}</h3>
    </template>
    <div class="content">
      <InfoBox
        class="mt-2"
        :text="$t('message.reviews.aiReply.aiSettingsTip1')"
      />
      <InfoBox
        class="mt-6"
        :text="$t('message.reviews.aiReply.aiSettingsTip2')"
      />
      <v-textarea
        name="text"
        v-model="value"
        counter="300"
        v-validate="'max:300'"
        :data-vv-name="$t('message.reviews.aiReply.instructionsForAi')"
        :error-messages="
          errors.collect($t('message.reviews.aiReply.instructionsForAi'))
        "
        :label="`${$t('message.reviews.aiReply.instructionsForAi')} *`"
        clearable
        no-resize
        rows="6"
        :loading="isLoading"
      ></v-textarea>
    </div>
    <template #actions>
      <ui-button
        :disabled="errors.any()"
        color="primary"
        class="submit-btn"
        @click="saveSettings"
      >
        {{ $t("message.common.save") }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
import InfoBox from "@/components/ui/InfoBox.vue";
import reviewsService from "@/services/reviews";
import serviceHandler from "@/helpers/handlers/service";

export default {
  name: "AiSettingsDialog",
  components: {
    InfoBox
  },
  data() {
    return {
      isLoading: false,
      value: ""
    };
  },
  async created() {
    this.isLoading = true;
    await this.getAiReplyConfig();
    this.isLoading = false;
  },
  methods: {
    async saveSettings() {
      try {
        await reviewsService.patchAiReplyConfig({
          additional_instructions: this.value
        });
      } finally {
        this.$emit("close");
      }
    },
    async getAiReplyConfig() {
      const response = await serviceHandler(reviewsService.getAiReplyConfig());
      this.value = response.additional_instructions;
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  color: $gray-dark;
  @include font-size(16px);
  font-weight: 500;

  & > * + * {
    margin-top: $spacing * 2;
  }
}

.submit-btn {
  width: 100%;
}
</style>
